// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"275f24c4","140":"275f24c4","452":"275f24c4","688":"803a53fd"}[chunkId] + ".chunk.css";
};